const $ = jQuery.noConflict();
/* eslint-disable */
'use strict';
const Register = {
	$first_name_field: null,
	$last_name_field: null,
	$email_field: null,
	$password_field: null,
	$password_repeat_field: null,
	$register_form: null,

	init: function() {
		if (!window.location.pathname.includes('/register')) {
			return;
		}
		this.initDOM();
		this.onFormSubmit();
	},

	initDOM: function() {
		Register.$first_name_field = $('#register-first-name');
		Register.$last_name_field = $('#register-last-name');
		Register.$email_field = $('#reg-email');
		Register.$password_field = $('#reg-create-pass');
		Register.$password_repeat_field = $('#reg-repeat-pass');
		Register.$register_form = $('.register-block__btn');
	},

	onFormSubmit: function() {
		this.$register_form.on('click', function() {
			const flag = Register.validateFields();
			if (flag) {
				Register.sendRequest();
			} else {
				$('.form-loader').toggleClass('is-active', false);
			}
		});
	},

	sendRequest: function() {
		$.ajax({
			url: window.fwsLocalized.ajaxUrl,
			type: 'POST',
			dataType: 'JSON',
			data: {
				action: 'register-user',
				first_name: Register.$first_name_field.val(),
				last_name: Register.$last_name_field.val(),
				email: Register.$email_field.val(),
				password: Register.$password_field.val(),
				redirect: window.location.origin + '/my-account/'
			},
			success: (response) => {
				if (response.success) {
					window.location = window.location.origin + '/my-account/edit-account';
				} else if (response.data.errors) {
					$('.js-general-errors').css('display', 'block');
					$('.js-general-errors').text(response.data.errors);
				}
			},
			complete: () => {
				$('.form-loader').toggleClass('is-active', false);
			}
		});
	},

	validateFields: function() {
		let flags = [];
		if (!Register.$first_name_field.val()) {
			Register.$first_name_field.next('.field_error').text('First name is required');
			Register.$first_name_field.addClass('error-occured');
			flags.push(false)
		} else {
			Register.$first_name_field.next('.field_error').text('');
			Register.$first_name_field.removeClass('error-occured');
			flags.push(true)
		}

		if (!Register.$last_name_field.val()) {
			Register.$last_name_field.next('.field_error').text('Last name is required');
			Register.$last_name_field.addClass('error-occured');
			flags.push(false)
		} else {
			Register.$last_name_field.next('.field_error').text('');
			Register.$last_name_field.removeClass('error-occured');
			flags.push(true)
		}

		if (!Register.$email_field.val()) {
			Register.$email_field.next('.field_error').text('Email is required');
			Register.$email_field.addClass('error-occured');
			flags.push(false)
		} else {
			Register.$email_field.next('.field_error').text('');
			Register.$email_field.removeClass('error-occured');
			flags.push(true)
		}

		if (!Register.$password_field.val()) {
			Register.$password_field.next('.field_error').text('Password is required');
			Register.$password_field.addClass('error-occured');
			return false;
		}  else {
			Register.$password_field.next('.field_error').text('');
			Register.$password_field.removeClass('error-occured');
		}

		if (Register.$password_field.val().length < 8) {
			Register.$password_field.next('.field_error').text('Password should contain at least 8 characters');
			Register.$password_field.addClass('error-occured');
			return false;
		} else {
			Register.$password_field.next('.field_error').text('');
			Register.$password_field.removeClass('error-occured');
		}

		if (Register.$password_repeat_field.val() !== Register.$password_field.val()) {
			Register.$password_repeat_field.next('.field_error').text('Passwords are not matching');
			Register.$password_repeat_field.addClass('error-occured');
			return false;
		} else {
			Register.$password_repeat_field.next('.field_error').text('');
			Register.$password_repeat_field.removeClass('error-occured');
		}

		if (!Register.$password_field.val()) {
			Register.$password_field.next('.field_error').text('Password is required');
			Register.$password_field.addClass('error-occured');
			return false;
		} else {
			Register.$password_field.next('.field_error').text('');
			Register.$password_field.removeClass('error-occured');
		}

		return !flags.includes(false) ? true : false;
	},
};

export default Register;
